import { stages } from './Status';

export interface Address {
  firstName: string;
  lastName: string;
  houseNo: string;
  zip: string;
  city: string;
}

export interface TrackingStatusResponse {
  statuses?: TrackingResponse[];
  error?: TrackingResponseError;
  carrier?: string;
}

export interface DepotAddress {
  depotName: string | null;
  street: string | null;
  houseNo: string | null;
  city: string | null;
  zip: string | null;
}

export interface TrackingResponse {
  timeStamp: string | null;
  statusCode: number;
  status: string | null;
  deliveredTo: string | null;
  shipmentUserCarrier: string | null;
  deliveryAddress: Address | null;
  carrierDestinationCode: string;
  productTypeCode: string;
  customerNumber?: string;
  returnCode: string | null;
  returnCodeDescription: string | null;
  stage: stages;
  statusDescription: string;
  label: string;
  depotAddress: DepotAddress;
  shipmentNumber: string;
}

export interface TrackingResponseError {
  message?: string;
  status?: number;
}

export interface PostCodeCheckResponse {
  label: string | undefined;
  info: string | undefined;
}

export const defaultDeliveredTo: PostCodeCheckResponse = {
  label: '',
  info: ''
};
